import { Flex, Typography} from "antd";
import {DiscountCode} from "../DiscountCode/DiscountCode";
import "./AgreementVoucher.css";
import {AgreementTypeLabel} from "../../Common/AgreementTypeLabel/AgreementTypeLabel";
import {InfoLogo} from "../../Common/InfoLogo/InfoLogo";

const {Text} = Typography;

export interface AgreementVoucherProps {
    organizationId: number;
    agreementType: string;
    changeVisus: string;
    refundCondition: string;
    discountCode: number;
    locationGroupCode: string;
    eligibilityScope:string;
}

export function AgreementVoucher(props: AgreementVoucherProps) {

    const getBrand = (locationGroupCode: string): string => {
        if (locationGroupCode === "SV") {
            return "Salmoiraghi & Viganò";
        } else if (locationGroupCode === "SVF") {
            return "Franchising";
        } else {
            return "Grand Vision";
        }
    };

    const brand = getBrand(props.locationGroupCode)

    const cambioVisus = props.changeVisus ? props.changeVisus : "-";
    const refundCondition = props.refundCondition ? props.refundCondition : "-";
    const eligibilityScope = props.eligibilityScope ? props.eligibilityScope : "";

    return (
        <>

            <Flex className={"agreement-voucher"} justify={"flex-start"} gap={"large"}>

                <Flex vertical >
                    <InfoLogo organizationId={props.organizationId} width={200}></InfoLogo>
                    <DiscountCode discountCode={props.discountCode}></DiscountCode>
                </Flex>

                <Flex vertical gap={"small"} style={{ flex: 1 }}>
                    <Flex align={"center"} gap={"small"} style={{ width: '100%' }}>
                        <div style={{width: '250px',whiteSpace: 'nowrap' }}>
                            <Text strong>Brand:</Text> {brand}
                        </div>
                        <div  style={{marginLeft: 'auto'}}>{eligibilityScope}</div>
                    </Flex>
                    <Flex align={"center"} gap={"small"}>
                        <Text strong>Gestione: </Text> <AgreementTypeLabel
                        value={props.agreementType}></AgreementTypeLabel>
                    </Flex>
                    <Flex align={"center"} gap={"small"}>
                        <Text strong>Cambio visus: </Text> {cambioVisus}
                    </Flex>
                    <Flex align={"center"} gap={"small"}>
                        <Text strong>Condizione di rimborso: </Text> {refundCondition}
                    </Flex>
                </Flex>

            </Flex>
        </>
    )
}
